import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { UiState, ThemeMode } from '@/types'

const stored = localStorage.getItem('themeMode') as ThemeMode | null

const initialState: UiState = {
  sidebarCollapsed: false,
  aiPanelOpen: false,
  activeRoute: 'Dashboard',
  toastMessage: null,
  themeMode: stored ?? 'dark',
  workspaceStep: 0,
  searchQuery: '',
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload
    },
    toggleAIPanel(state) {
      state.aiPanelOpen = !state.aiPanelOpen
    },
    setAIPanelOpen(state, action: PayloadAction<boolean>) {
      state.aiPanelOpen = action.payload
    },
    setActiveRoute(state, action: PayloadAction<string>) {
      // Search is scoped to a page — don't carry it to the next one.
      if (state.activeRoute !== action.payload) state.searchQuery = ''
      state.activeRoute = action.payload
    },
    showToast(state, action: PayloadAction<string>) {
      state.toastMessage = action.payload
    },
    clearToast(state) {
      state.toastMessage = null
    },
    setThemeMode(state, action: PayloadAction<ThemeMode>) {
      state.themeMode = action.payload
      localStorage.setItem('themeMode', action.payload)
    },
    toggleThemeMode(state) {
      const next: ThemeMode = state.themeMode === 'dark' ? 'light' : 'dark'
      state.themeMode = next
      localStorage.setItem('themeMode', next)
    },
    setWorkspaceStep(state, action: PayloadAction<number>) {
      state.workspaceStep = action.payload
    },
    setSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload
    },
  },
})

export const {
  toggleSidebar,
  setSidebarCollapsed,
  toggleAIPanel,
  setAIPanelOpen,
  setActiveRoute,
  showToast,
  clearToast,
  setThemeMode,
  toggleThemeMode,
  setWorkspaceStep,
  setSearchQuery,
} = uiSlice.actions
export default uiSlice.reducer
